import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import {useState} from "react";
import {hu} from "date-fns/locale";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";

const ErrorHandlingDatePicker = ({validators, onValChange, check, ...rest}) => {
    const [error, setError] = useState("");

    const validate = (val) => {
        setError("");
        for (let validator of validators) {
            const validatedResult = validator(val);
            if (!validatedResult.result) {
                if (check) check(true);
                return setError(validatedResult.error);
            }
        }
        if (check) check(false);
    };

    return (<LocalizationProvider dateAdapter={AdapterDateFns} locale={hu}>
            <DatePicker
                inputFormat="yyyy-MM-dd"
                {...rest}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        error={Boolean(error)}
                        helperText={error || params.helperText}
                        variant='standard'
                    />
                )}
                onChange={e => {
                    onValChange(e);
                    validate(e);
                }}
            />
        </LocalizationProvider>
    );
};

// Example date validators
const validateFutureDate = (value) => {
    const now = new Date();
    const res = value > now;
    return {
        result: res,
        error: "A dátumnak a jövőben kell lennie",
    };
};

const validateRequiredDate = (value) => {
    return {
        result: Boolean(value),
        error: "A dátum nem maradhat üresen",
    };
};

const validateRequiredAge = (value) => {
    const birthDate = new Date(value);
    const today = new Date();

    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Adjust age if birthday hasn't occurred yet this year
    const exactAge = monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0) ? age : age - 1;

    const isValid = exactAge >= 16 && exactAge <= 50;
    return {
        result: isValid,
        error: "Az időpont foglaló rendszer 16 és 50 év közötti sportolók részére elérhető! Amennyiben 16 alatt vagy, másik linken kell foglalnod!",
    };
};

export default ErrorHandlingDatePicker;
export {validateFutureDate, validateRequiredDate, validateRequiredAge};
